import React, { useEffect, useState } from 'react'
import Select from 'react-select'
import { toast } from 'react-toastify'
import { SimpleFetch, store } from '../../../../_helpers'
import { Loader } from '../../../../_components';

export default function Events(props) {
  const [ loading, setLoading ] = useState(true)
  const [ categories, setCategories ] = useState([])
  const [ selectedCategory, setSelectedCategory ] = useState()
  const [ keys, setKeys ] = useState([])
  const [ selectedKey, setSelectedKey ] = useState()
  const [ values, setValues ] = useState([])
  const [ selectedValue, setSelectedValue ] = useState()

  useEffect(() => {
    async function requestAvailableCategories() {
      const req = await SimpleFetch(`GET`, {}, {}, `momentum`, `person/event/${store.getState().changeDomainReducer.selectedDomain.domain_uuid}`);
      if ( req.status !== 200 ) {
        return toast.error("Ocorreu um erro ao listar as categorias disponíveis. Tente novamente mais tarde.", { position: toast.POSITION.TOP_RIGHT, className: 'toast-error' });
      }

      setCategories(req.data.map(a => {return {label: a.parent_category, value: a.uuid}}))
      setLoading(false)
    }

    requestAvailableCategories();
  }, []);

  const handleCategoryChange = async (e, key) => {
    setSelectedCategory(e.value);
    
    const arr = props.localData.trigger ? props.localData.trigger : [];

    const req = await SimpleFetch(`GET`, {}, {}, `momentum`, `person/event/filters/${e.value}`);
    if ( req.status !== 200 ) {
      return toast.error("Ocorreu um erro ao listar as chaves disponíveis. Tente novamente mais tarde.", { position: toast.POSITION.TOP_RIGHT, className: 'toast-error' });
    }

    setKeys(req.data.map(a => {return {label: a, value: a}}))
    props.setLocalData({...props.localData, trigger: {...arr, [key]: e.label}})
  }

  const handleKeyChange = async ({value}, key) => {
    setSelectedKey(value);

    const arr = props.localData.trigger ? props.localData.trigger : [];

    const req = await SimpleFetch(`GET`, {}, {}, `momentum`, `person/event/filters/${selectedCategory}/key/${value}`);
    if ( req.status !== 200 ) {
      return toast.error("Ocorreu um erro ao listar os valores disponíveis. Tente novamente mais tarde.", { position: toast.POSITION.TOP_RIGHT, className: 'toast-error' });
    }

    setValues(req.data.map(a => {return {label: a, value: a}}))
    props.setLocalData({...props.localData, trigger: {...arr, [key]: value}});
    setLoading(false);
  }

  const handleChange = async (e, key) => {
    const arr = props.localData.trigger ? props.localData.trigger : [];
    
    if ( key === "comparation" )
      return props.setLocalData({...props.localData, trigger: {...arr, [key]: e.value}});

    if ( !e || e.length === 0 )
      return props.setLocalData({...props.localData, trigger: {...arr, [key]: []}});

    let multiOnlyValues = e.map(value => {return value.value});
    return props.setLocalData({...props.localData, trigger: {...arr, [key]: multiOnlyValues}});
  }

  return (
    <>
      {
        !loading || categories.length !== 0 ? 
          <Select
            options={categories}
            className="selectable"
            placeholder="Selecione a categoria do evento"
            onChange={(e) => handleCategoryChange(e, "parentCategory")}
          />
        : <Loader className="relative in-block is-blue" />
      }

      { selectedCategory ?
        keys.length !== 0 ?
          <Select
            options={keys}
            className="selectable"
            placeholder="Selecione a chave da categoria do evento"
            onChange={(e) => handleKeyChange(e, "key")}
          />
        : <Loader className="relative in-block is-blue" />
      : null }

      { selectedKey ?
        values.length !== 0 ?
          <>
            <div className="flex__break"></div>
            <Select
              options={[
                {label: "Igual a", value: "=="},
                {label: "Diferente de", value: "!="},
                {label: "Contém", value: "contain"},
                {label: "Não contém", value: "notcontain"}
              ]}
              className="selectable"
              placeholder="Defina o método de comparação dos valores"
              onChange={(e) => handleChange(e, "comparation")}
            />
            <Select
              options={values}
              className="selectable"
              placeholder="Insira o valor do evento"
              onChange={(e) => handleChange(e, "value")}
              defaultValue={selectedValue}
              isMulti
            />
          </>
        : <Loader className="relative in-block is-blue" />
      : null}
    </>
  )
}